import { z } from "zod";

export const RANKINGS_DEFAULT_LIMIT = 50;
export const RANKINGS_MAX_LIMIT = 100;

export const rankingEntrySchema = z.object({
  rank: z.number().int(),
  userId: z.string(),
  displayName: z.string(),
  avatarUrl: z.string().nullable(),
  level: z.number().int(),
  totalXp: z.number().int(),
});

export type RankingEntryDTO = z.infer<typeof rankingEntrySchema>;

export const rankingsResponseSchema = z.object({
  entries: z.array(rankingEntrySchema),
  /** The requesting user's own rank/entry, even if outside `entries`. Null if they have no progression row (shouldn't happen post-login). */
  currentUser: rankingEntrySchema.nullable(),
});

export type RankingsResponse = z.infer<typeof rankingsResponseSchema>;
